module.exports = __webpack_public_path__ + "static/img/login_bg.ce4bdb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/login_bg.png
// module id = 185
// module chunks = 103